<template>
    <div class="console-body-content-item console-video-settings">
        <div class="console-body-content-item-title">
            <span>Video Settings</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Title: </span><span class="console-body-text text-wrap">{{ getVideoData.title }}</span>
        </div>
        <div class="console-body-line" style="max-width: 400px;">
            <span class="fw-bold">Description: </span><span class="console-body-text text-wrap">{{ getVideoData.description }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Video Duration: </span><span class="console-body-text">{{ getVideoDuration }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">FPS: </span><span class="console-body-text">{{ getVideoMetrics.fps }}</span>
        </div>
        <div class="console-body-line">
            <span class="fw-bold">Frame(1) in Milliseconds: </span><span class="console-body-text">{{ getVideoMetrics.oneFrameMilliseconds }}</span>
        </div>
        <div class="console-body-line" style="max-width: 400px;">
            <span class="fw-bold">Start Date: </span><span class="console-body-text text-wrap">{{ getVideoData.startDate }}</span>
        </div>
        <div class="console-body-line" style="max-width: 400px;">
            <span class="fw-bold">End Date: </span><span class="console-body-text text-wrap">{{ getVideoData.endDate }}</span>
        </div>
        <div class="console-body-line" style="max-width: 400px;">
            <span class="fw-bold">Status: </span><span class="console-body-text text-wrap">{{ getVideoData.videoStatus.description }}</span>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { timeFormat } from "@/playerVue3/services/misc-service";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getVideoDuration = computed(() => {
    return timeFormat(store.getVideoData.duration);
});

const getVideoData = computed(() => {
    return store.getVideoData;
});

const getVideoMetrics = computed(() => {
    return store.getPlayerMetrics;
});

// METHODS

// LIFECYCLE HOOKS
</script>
